export default {
    seo: {
        title: 'Regula Data | Duomenų integracija ir automatizavimas verslui',
        description: 'Padėsime atsisakyti rankinio duomenų kopijavimo iš sistemos į sistemą. Pasiūlysime integracijas, kurios duomenis tarp jūsų naudojamų sistemų sinchronizuos automatiškai.',
        ogTitle: 'Sujunkite savo verslo įrankius su Regula Data',
        ogDescription: 'Padėsime atsisakyti rankinio duomenų kopijavimo iš sistemos į sistemą. Pasiūlysime integracijas, kurios duomenis tarp jūsų naudojamų sistemų sinchronizuos automatiškai.',
        keywords: 'duomenų integracija, procesų automatizavimas, duomenų sinchronizavimas, SaaS integracijos, verslo įrankių susiejimas, duomenų srautų valdymas, Rivile integracija, Begin integracija, alkotesteris.lt integracija, butenta integracija, api integracija, api'
    },
    header: {
        howItWorks: 'Kaip tai veikia',
        pricing: 'Kainodara',
        contact: 'Kontaktai',
        blog: 'Tinklaraštis',
        login: 'Prisijungti'
    },
    hero: {
        badge: 'Duomenų integracija',
        title: 'Sujunkite savo verslo įrankius',
        subtitle: 'Padėsime atsisakyti rankinio duomenų kopijavimo iš sistemos į sistemą. Pasiūlysime integracijas, kurios duomenis tarp jūsų naudojamų sistemų sinchronizuos automatiškai.',
        cta: 'Pradėti dabar',
        ctaShort: 'Pradėti',
        learnMore: 'Sužinoti daugiau',
        bullet1: 'Skaidri kainodara',
        bullet2: 'Plačios integracijų galimybės',
        bullet3: 'Sukurta pagal jūsų verslo poreikius',
        dashboardAlt: 'Regula Data valdymo skydas'
    },
    features: {
        badge: 'Funkcijos',
        title: 'Viskas, ko reikia efektyviam darbui',
        subtitle: 'Galingi duomenų integracijos įrankiai, sukurti užtikrinti duomenų patikimumą ir saugumą.',
        browse: {
            title: 'Paprastas integracijų diegimas',
            description: 'Rinkitės iš mūsų plačios integracijų bibliotekos. Jei reikiamos integracijos nėra – sukursime ją specialiai jūsų verslui.'
        },
        configure: {
            title: 'Greita konfigūracija',
            description: 'Pateikite prisijungimo duomenis ir pasirinkite norimus nustatymus. Visą techninį sudėtingumą „po kapotu“ sutvarkome mes.'
        },
        activate: {
            title: 'Automatizuotas procesas',
            description: 'Nustatykite norimą integracijos grafiką ir mėgaukitės automatine duomenų sinchronizacija. Nebereikės rankiniu būdu kopijuoti duomenų iš vienos sistemos į kitą.'
        },
        monitoring: {
            title: 'Stebėsena realiu laiku',
            description: 'Sekite integracijų našumą ir duomenų kokybę gyvai. Gaukite momentinius įspėjimus apie bet kokius nesklandumus.'
        },
        security: {
            title: 'Aukščiausio lygio saugumas',
            description: 'Bankinio lygio šifravimas ir griežti atitikties standartai. Jūsų duomenys saugūs kiekviename etape.'
        },
        scalability: {
            title: 'Automatinis mastelio keitimas',
            description: 'Sistema lengvai susidoroja su bet kokiu duomenų kiekiu – nuo tūkstančių iki milijonų įrašų sklandžiai.'
        }
    },
    howItWorks: {
        badge: 'Procesas',
        title: 'Trys žingsniai iki vientisos sistemos',
        subtitle: 'Supaprastintas procesas, leidžiantis greitai susieti jūsų naudojamus įrankius.',
        step1: {
            title: 'Papasakokite savo poreikius',
            description: 'Susisiekite su mumis ir pasidalinkite, kokias sistemas norite sujungti. Aptarsime duomenų srautų poreikius ir rasime geriausią sprendimą jūsų verslui.'
        },
        step2: {
            title: 'Parengsime jums integraciją',
            description: 'Jei turime tinkamą integraciją savo bibliotekoje – padėsime ją sukonfigūruoti. Jei ne – pasiūlysime sukurti integraciją pagal jūsų poreikius.'
        },
        step3: {
            title: 'Mėgaukitės rezultatais',
            description: 'Kai jūsų integracija aktyvuota, duomenys pradeda judėti tarp sistemų automatiškai – daugiau jokio rankinio duomenų perkelinėjimo tarp sistemų.'
        },
        enterprise: {
            title: 'Aukščiausi patikimumo standartai',
            description: 'Mūsų integracijos atitinka aukščiausius reikalavimus, kad užtikrintų nepertraukiamą duomenų srautą.',
            performance: {
                title: 'Sprendimai pagal poreikius',
                description: 'Reikia specifinės integracijos? Mūsų komanda sukurs ją tiksliai pagal jūsų verslo specifiką.'
            },
            security: {
                title: 'Išbandyta ir paruošta darbui',
                description: 'Kiekviena integracija yra nuodugniai testuojama ir nuolat prižiūrima bei atnaujinama.'
            },
            support: {
                title: 'Nuolatinis tobulinimas',
                description: 'Aktyviai atnaujiname savo platformą, atsižvelgdami į klientų atsiliepimus ir technologijų pokyčius bei integruojamų sistemų pasikeitimus.'
            },
            imageAlt: 'Verslo komandos bendradarbiavimas'
        }
    },
    integrations: {
        badge: 'Integracijos',
        title: 'Sujunkite savo verslo ekosistemą',
        subtitle: 'Integracijų biblioteka, kuri auga kartu su jūsų poreikiais.',
        categories: {
            crm: 'CRM',
            marketing: 'Rinkodara',
            analytics: 'Analitika',
            productivity: 'Produktyvumas',
            ecommerce: 'El. prekyba',
            support: 'Palaikymas'
        },
        cards: {
            restApi: {
                title: 'REST API',
                description: 'Galime sujungti betkokias sistemas kurios turi API sąsają.'
            },
            saas: {
                title: 'SaaS platformos',
                description: 'Tiesioginės integracijos tarp verslo programų, kurias jūsų komanda naudoja kasdien.'
            },
            webhooks: {
                title: 'Webhook',
                description: 'Sinchronizuokite duomenis realiu laiku naudodamiesi webhook integracijomis.'
            }
        },
        custom: {
            title: 'Reikia specifinės integracijos?',
            description: 'Kuriame individualias integracijas pagal užsakymą. Pasakykite, ko jums reikia, ir mes tai įgyvendinsime.',
            cta: 'Užsakyti integraciją'
        }
    },
    pricing: {
        badge: 'Kainodara',
        title: 'Paprasta ir skaidri kainodara',
        subtitle: 'Pasirinkite planą pagal sinchronizavimo dažnumą.',
        weekly: {
            title: 'Savaitinis planas',
            price: '39',
            currency: '€',
            period: 'už integraciją / mėn.',
            frequency: 'Sinchronizacija iki karto per savaitę',
            cta: 'Pradėti'
        },
        daily: {
            title: 'Dienos planas',
            price: '79',
            currency: '€',
            period: 'už integraciją / mėn.',
            frequency: 'Sinchronizacija iki karto dieną',
            badge: 'Populiariausias',
            cta: 'Pradėti'
        },
        hourly: {
            title: 'Valandinis planas',
            price: '129',
            currency: '€',
            period: 'už integraciją / mėn.',
            frequency: 'Sinchronizacija iki karto per valandą',
            cta: 'Pradėti'
        },
        webhook: {
            title: 'Webhook integracija',
            price: 'Individuali kaina',
            period: 'derinama pagal poreikius',
            frequency: 'Sinchronizacija realiam laike (pagal įvykį)',
            cta: 'Susisiekti'
        },
        features: {
            setup: 'Greitas ir paprastas diegimas',
            monitoring: 'Stebėjimas realiu laiku',
            support: 'Palaikymas el. paštu'
        },
        vatNote: 'be PVM',
        customNote: '* Individualioms integracijoms, kurių nėra bibliotekoje, gali būti taikomas vienkartinis kūrimo mokestis.'
    },
    contact: {
        badge: 'Susisiekite',
        title: 'Norite optimizuoti savo procesus?',
        subtitle: 'Susisiekite su mumis dėl savo integracijų poreikių.',
        form: {
            name: 'Vardas ir pavardė',
            email: 'El. pašto adresas',
            company: 'Įmonės pavadinimas',
            phone: 'Telefono numeris',
            message: 'Papasakokite apie savo integracijos poreikius',
            submit: 'Siųsti žinutę',
            sending: 'Siunčiama...',
            namePlaceholder: 'Jonas Jonaitis',
            emailPlaceholder: "jonas{'@'}imone.lt",
            companyPlaceholder: 'Jūsų įmonė, UAB',
            phonePlaceholder: '+370 600 00000',
            privacyNotice: {
                before: 'Pateikdami formą sutinkate su',
                privacy: 'privatumo politika',
                between: 'ir',
                terms: 'paslaugų teikimo sąlygomis',
                after: '.'
            }
        },
        success: 'Dėkojame! Jūsų žinutė gauta, netrukus su jumis susisieksime.',
        errors: {
            validation: 'Prašome teisingai užpildyti visus laukus.',
            captcha: 'Prašome užbaigti saugos patikrą.',
            rateLimit: 'Per daug bandymų. Pabandykite dar kartą po kelių minučių.',
            generic: 'Įvyko klaida. Bandykite dar kartą arba susisiekite tiesiogiai.'
        }
    },
    cta: {
        title: 'Pasiruošę sujungti savo įrankius?',
        subtitle: 'Prisijunkite prie įmonių, kurios naudoja Regula Data sinchronizuoti duomenis tarp savo naudojamų sistemų.',
        getStarted: 'Pradėti dabar',
        contactSales: 'Susisiekti',
        benefit1: 'Greitas procesas',
        benefit2: 'Integracijos pagal jūsų poreikius',
        benefit3: 'Pritaikyta jūsų verslui'
    },
    blog: {
        title: 'Tinklaraštis',
        description: 'Naujausi Regula Data straipsniai ir įžvalgos',
        readMore: 'Skaityti daugiau',
        publishedOn: 'Paskelbta',
        backToBlog: 'Grįžti į tinklaraštį',
        noPosts: 'Tinklaraščio įrašų dar nėra.',
        notFound: 'Įrašas nerastas',
        notFoundDescription: 'Tinklaraščio įrašas, kurio ieškote, neegzistuoja.',
        calculator: {
            title: 'Apskaičiuokite savo išlaidas',
            subtitle: 'Įveskite vieną pasikartojančią užduotį ir pamatykite, kiek ji iš tikrųjų kainuoja jūsų verslui.',
            employeeCost: 'Darbo vietos kaina',
            month: 'mėn.',
            duration: 'Užduoties trukmė',
            frequency: 'Kaip dažnai?',
            units: {
                min: 'min',
                hrs: 'val.',
            },
            frequencies: {
                daily: 'Kiekvieną darbo dieną',
                weekly: 'Kartą per savaitę',
                monthly: 'Kartą per mėnesį',
            },
            results: {
                perMonth: 'per mėnesį',
                perYear: 'per metus',
                hours: 'valandos',
                or: 'arba',
            },
            note: 'Efektyvus valandinis įkainis: {rate} (darbo vietos kaina ÷ 176 darbo val./mėn.)',
        },
    },
    footer: {
        copyright: '© 2026 Regula Data. Visos teisės saugomos.'
    },
    legal: {
        privacy: {
            title: 'Privatumo politika',
            lastUpdated: 'Paskutinį kartą atnaujinta: 2026 m. vasario 4 d.',
            introduction: {
                title: '1. Įvadas',
                content: 'Šioje Privatumo politikoje paaiškiname, kaip Regula Data renka ir tvarko asmens duomenis, pateiktus per kontaktų formą mūsų tinklalapyje. Esame įsipareigoję saugoti jūsų privatumą ir atsakingai valdyti duomenis.'
            },
            informationCollected: {
                title: '2. Kokią informaciją renkame',
                content: 'Kai pateikiate mūsų kontaktų formą, renkame šią informaciją:',
                items: [
                    'Jūsų vardą ir pavardę',
                    'Jūsų el. pašto adresą',
                    'Jūsų telefono numerį (jei pateikėte)',
                    'Jūsų įmonės pavadinimą',
                    'Žinutę, kurioje aprašote savo integracijos poreikius'
                ]
            },
            howWeUse: {
                title: '3. Kaip naudojame jūsų informaciją',
                content: 'Pateiktą informaciją naudojame, kad:',
                items: [
                    'Atsakytume į jūsų užklausą apie mūsų paslaugas',
                    'Bendrautume su jumis dėl integracijos poreikių',
                    'Pateiktume informaciją apie Regula Data sprendimus',
                    'Patenkintume jūsų prašymą dėl individualių integracijų ar paslaugų'
                ]
            },
            dataSharing: {
                title: '4. Duomenų dalijimasis',
                content: 'Mes neparduodame jūsų asmens informacijos. Jūsų kontaktiniai duomenys gali būti perduoti mūsų el. pašto paslaugų teikėjui, kad gautume jūsų užklausą. Jūsų informacija nebus dalijamasi su jokiomis kitomis trečiosiomis šalimis be jūsų sutikimo.'
            },
            dataSecurity: {
                title: '5. Duomenų saugumas',
                content: 'Naudojame standartines saugumo priemones, kad apsaugotume jūsų informaciją nuo neteisėtos prieigos. Jūsų duomenys perduodami saugiai ir saugomi naudojant pramonės standartų šifravimo praktiką. Tačiau joks perdavimo per internetą metodas nėra 100% saugus.'
            },
            yourRights: {
                title: '6. Jūsų teisės (BDAR)',
                content: 'Pagal Bendrąjį duomenų apsaugos reglamentą (BDAR) turite teisę:',
                items: [
                    'Gauti prieigą prie saugomų asmens duomenų',
                    'Prašyti ištaisyti netikslią informaciją',
                    'Prašyti ištrinti savo asmens duomenis',
                    'Nesutikti su asmens duomenų tvarkymu',
                    'Bet kada atšaukti sutikimą'
                ]
            },
            cookies: {
                title: '7. Slapukai',
                content: 'Mūsų svetainėje naudojami tik griežtai privalomi slapukai, užtikrinantys saugumą ir sklandų funkcionalumą. Jie padeda apsaugoti svetainę nuo piktnaudžiavimo bei kenkėjiško srauto, kartu patvirtindami vartotojų tapatybę pildant kontaktų formas. Nenaudojame slapukų reklamai, analitikai ar sekimui.'
            },
            changes: {
                title: '8. Politikos pakeitimai',
                content: 'Kartais galime atnaujinti šią Privatumo politiką. Bet kokie pakeitimai bus paskelbti šiame puslapyje su atnaujinta data. Jūsų toliau tęsiamas svetainės naudojimas po pakeitimų reiškia sutikimą.'
            },
            contact: {
                title: '9. Susisiekite su mumis',
                content: "Jei turite klausimų apie šią Privatumo politiką arba norite pasinaudoti duomenų apsaugos teisėmis, susisiekite su mumis: info{'@'}reguladata.lt"
            }
        },
        terms: {
            title: 'Paslaugų teikimo sąlygos',
            lastUpdated: 'Paskutinį kartą atnaujinta: 2026 m. sausio 29 d.',
            acceptance: {
                title: '1. Sąlygų priėmimas',
                content: 'Naudodamiesi kontaktų forma Regula Data tinklalapyje, sutinkate su šiomis Paslaugų teikimo sąlygomis. Jei nesutinkate, prašome nepateikti formos.'
            },
            services: {
                title: '2. Svetainė ir kontaktų forma',
                content: 'Ši svetainė teikia informaciją apie Regula Data integracijos paslaugas. Kontaktų forma leidžia pateikti užklausas apie mūsų paslaugas. Siekiame operatyviai atsakyti į visas užklausas.'
            },
            obligations: {
                title: '3. Vartotojo pareigos',
                content: 'Naudodamiesi svetaine ir kontaktų forma, sutinkate:',
                items: [
                    'Pateikti tikslią ir teisingą informaciją',
                    'Naudoti svetainę tik teisėtais tikslais',
                    'Nesiųsti šlamšto, kenkėjiško turinio ar neteisingos informacijos',
                    'Nebandyti trikdyti svetainės veikimo'
                ]
            },
            intellectualProperty: {
                title: '4. Intelektinė nuosavybė',
                content: 'Visas šios svetainės turinys, įskaitant tekstą, grafiką, logotipus ir dizainą, yra Regula Data nuosavybė ir saugomas autorių teisių bei kitų intelektinės nuosavybės įstatymų. Negalite dauginti ar platinti jokio turinio be leidimo.'
            },
            liability: {
                title: '5. Atsakomybės apribojimas',
                content: 'Regula Data neatsako už jokią žalą, atsirandančią dėl kontaktų formos ar svetainės naudojimo. Neteikiame garantijų dėl šioje svetainėje esančios informacijos tikslumo ar išsamumo. Naudojatės forma savo rizika.'
            },
            termination: {
                title: '6. Prieigos nutraukimas',
                content: 'Pasiliekame teisę apriboti prieigą prie svetainės piktnaudžiavimo atveju. Tai neturi įtakos jūsų duomenų apsaugos teisėms.'
            },
            governingLaw: {
                title: '7. Taikoma teisė',
                content: 'Šios Sąlygos reglamentuojamos Lietuvos Respublikos įstatymais. Visi ginčai bus sprendžiami Vilniaus, Lietuva, teismuose.'
            },
            changes: {
                title: '8. Sąlygų pakeitimai',
                content: 'Galime bet kada atnaujinti šias Sąlygas paskelbdami pataisytas sąlygas šiame puslapyje. Jūsų toliau tęsiamas kontaktų formos naudojimas po pakeitimų reiškia sutikimą su atnaujintomis Sąlygomis.'
            },
            contact: {
                title: '9. Kontaktinė informacija',
                content: "Jei turite klausimų dėl šių Sąlygų, susisiekite su mumis: info{'@'}reguladata.lt"
            }
        }
    }
};